@keyframes vihc5b6 {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
.vihc5b0 {
  background-color: var(--pluma-color-surface-content);
  width: 100%;
  height: 100%;
  border-left: var(--pluma-border-width-0125) solid var(--pluma-color-scope-neutral-subtle-border);
  box-sizing: border-box;
  overflow: hidden;
}
.vihc5b1 {
  border: none;
  border-radius: var(--pluma-c-app-layout-content-radius, var(--pluma-c-_app-layout-content-radius)) var(--pluma-c-app-layout-content-radius, var(--pluma-c-_app-layout-content-radius)) 0 0;
  margin-right: var(--pluma-space-150);
}
.vihc5b2 {
  border-radius: 0;
  margin-right: 0;
  margin-top: calc(-1 * var(--pluma-c-app-layout-header-height, var(--pluma-c-_app-layout-header-height)));
  height: calc(100% + var(--pluma-c-app-layout-header-height, var(--pluma-c-_app-layout-header-height)));
  border-left: var(--pluma-border-width-0125) solid var(--pluma-color-scope-neutral-subtle-border);
}
.vihc5b3 {
  height: 100%;
  width: 100%;
}
.vihc5b4 {
  position: relative;
  width: 14px;
  flex-shrink: 0;
  cursor: ew-resize;
  margin-left: calc(-1 * var(--pluma-space-150));
  margin-right: -2px;
  z-index: 41;
}
.vihc5b4::after {
  content: "";
  position: absolute;
  right: 2px;
  top: 0;
  width: 1px;
  height: 100%;
  background-color: var(--pluma-color-scope-neutral-border);
  opacity: 0;
  transition: opacity 100ms ease-in-out;
}
.vihc5b4:hover::after {
  opacity: 1;
}
.vihc5b4:active::after {
  opacity: 1;
}
.vihc5b5 {
  height: 44px;
}
.vihc5b7::before {
  content: "";
  position: absolute;
  inset: 0;
  z-index: 1;
  pointer-events: none;
  border-radius: inherit;
  padding: var(--pluma-border-width-025);
  background: linear-gradient(135deg, var(--pluma-color-ai-ring-stop-02), var(--pluma-color-ai-ring-stop-03));
  -webkit-mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);
  -webkit-mask-composite: xor;
  mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);
  mask-composite: exclude;
  animation: vihc5b6 var(--pluma-motion-duration-moderate-01) var(--pluma-motion-easing-entrance-expressive) both;
}
@media not screen and (min-width: 1024px) {
  .vihc5b4 {
    display: none;
  }
}
@media (prefers-reduced-motion: reduce) {
  .vihc5b7::before {
    animation: none;
  }
}